import React from 'react';
import { Globe, Users, Target, Award } from 'lucide-react';
import { companyInfo } from '../mock';

const About = () => {
  const values = [
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Global Reach",
      description: "Connecting businesses worldwide with premium products through our international network"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Strategic Partnerships",
      description: "Collaborating with trusted manufacturers and suppliers to ensure quality and reliability"
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Customer Focus",
      description: "Dedicated to understanding and meeting the unique needs of each client"
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: "Quality Excellence",
      description: "Committed to delivering only the highest quality products and services"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-red-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">About March Global</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Building bridges in global trade since {companyInfo.founded}
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  {companyInfo.description}
                </p>
                <p className="text-lg">
                  Our journey began with a vision to create a reliable bridge between quality manufacturers and businesses worldwide. Through our strategic partnership with the esteemed Olives factory in Gimlek, Bursa, we ensure that our customers receive authentic, premium Mediterranean products.
                </p>
                <p className="text-lg">
                  In parallel, we have developed a robust network of international suppliers for industrial packaging and adhesive materials, providing comprehensive solutions for manufacturing and industrial needs across the globe.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img 
                src="https://images.unsplash.com/photo-1572777856134-4e658bbf3b78?w=600" 
                alt="Olive Production" 
                className="rounded-lg shadow-lg w-full h-64 object-cover"
              />
              <img 
                src="https://images.unsplash.com/photo-1697350481735-9e3c5b74ee35?w=600" 
                alt="Industrial Packaging" 
                className="rounded-lg shadow-lg w-full h-64 object-cover mt-8"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Values</h2>
            <p className="text-xl text-gray-600">The principles that guide everything we do</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4 text-[#02029E]">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#02029E] to-[#D41414] rounded-2xl p-12 text-white">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-4xl font-bold mb-6">Our Strategic Partnership</h2>
              <p className="text-xl text-blue-100 mb-6 leading-relaxed">
                We are proud to partner with the renowned Olives factory in Gimlek, Bursa, a region celebrated for its centuries-old tradition of olive cultivation and production.
              </p>
              <p className="text-lg text-blue-100 leading-relaxed">
                This partnership allows us to offer our clients access to premium Mediterranean olives and olive products, combining traditional expertise with modern quality standards.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
